import { HeartPulse } from "lucide-react";
import {
  KaizenHealthParamsSchema,
  defaultKaizenHealthParams,
  type KaizenHealthOutput,
  type KaizenHealthParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KaizenHealthWidget } from "./Component.js";

export const kaizenHealthDef: SqlWidgetDef<
  KaizenHealthParams,
  KaizenHealthOutput
> = {
  kind: "kaizenHealth",
  label: "Kaizen Health",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 360, h: 360 },
  defaultParams: defaultKaizenHealthParams,
  Component: KaizenHealthWidget,
  storage: "sql",
  schema: KaizenHealthParamsSchema,
  accent: "pb-tint-4",
  icon: HeartPulse,
  subtitle: "Current value-stream improvement health",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 360, height: 360 },
  dashboard: {
    icon: HeartPulse,
    defaultWidth: "medium",
    category: "Operations",
  },
};

registerWidget(kaizenHealthDef);
